const SignUp_ko = {
  ID_SIGNUP_TITLE: "회원가입",
  ID_SIGNUP_EMAIL: "이메일",
  ID_SIGNUP_PWD: "비밀번호",
  ID_SIGNUP_NICKNAME: "닉네임",
  ID_SIGNUP_VERIFY_CODE: "인증코드",
  ID_SIGNUP_EMAIL_PLACEHOLDER: "이메일을 입력해주세요.",
  ID_SIGNUP_ERROR_EMPTY_EMAIL: "이메일을 입력하세요.",
  ID_SIGNUP_EMAIL_VERIFY_BTN: "인증하기",
  ID_SIGNUP_PWD_PLACEHOLDER: "비밀번호 입력",
  ID_SIGNUP_NAME_PLACEHOLDER: "닉네임을 입력해주세요.",
  ID_SIGNUP_NAME_ERROR: "닉네임을 입력해주세요.",
  ID_SIGNUP_BDAY: "생년월일",
  ID_SIGNUP_PWD_DIGIT: "최소 8글자 이상",
  ID_SIGNUP_PWD_PATTERN: "영문, 숫자 조합",
  ID_SIGNUP_YEAR: "연도",
  ID_SIGNUP_MONTH: "월",
  ID_SIGNUP_DATE: "일",
  ID_SIGNUP_SUBMIT_BTN: "계정 만들기",
  ID_SIGNUP_LOGIN_DESC: "이미 레드브릭 회원이신가요? ",
  ID_SIGNUP_LOGIN_LINK: "로그인",
  ID_SIGNUP_AGREE_ALL: "모두 동의합니다.",
  ID_SIGNUP_AGREE_SERVICE: `[필수] (주)레드브릭 통합 {link}에 동의합니다.`,
  ID_SIGNUP_AGREE_SERVICE_LINK: "서비스 약관",
  ID_SIGNUP_AGREE_PRIVACY: "[필수] {link}에 동의합니다.",
  ID_SIGNUP_AGREE_PRIVACY_LINK: "개인정보처리방침",
  ID_SIGNUP_AGREE_MARKETING: "[선택] 서비스 정보 수신에 동의합니다.",
  ID_SIGNUP_SERVICE_TERMS:
    "본 약관은 회사가 제공하는 레드브릭, 위즈라이브 서비스 등에 공통 적용되며,\n본 약관에 동의함으로써 해당 서비스들은 별도 이용계약 체결없이 이용할 수 있습니다.",
  ID_SIGNUP_EMAIL_FORMAT_ERROR: "이메일 형식을 바르게 입력해주세요",
  ID_SIGNUP_EMAIL_DUPLICATE_ERROR: "이미 사용 중인 이메일입니다.",
  ID_SIGNUP_EMAIL_DUPLICATE_VALID: "사용 가능한 이메일입니다.",
  ID_SIGNUP_EMAIL_BIRTH_ERROR: "생년월일을 입력해주세요.",
  ID_SIGNUP_MAN_AGREE_ERR: "필수 약관 동의해주세요.",
  ID_SIGNUP_EMAIL_SERVICE_AGREE_ERROR: "서비스 약관 동의해주세요.",
  ID_SIGNUP_EMAIL_PRIVACY_AGREE_ERROR: "개인정보처리방침 동의해주세요.",
  ID_SIGNUP_CODE_VERIFY_BTN: "확인",
  ID_SIGNUP_EMAIL_SENDING: "발송중...",
  ID_SIGNUP_CODE_PLACEHOLDER: "인증코드를 입력해 주세요.",
  ID_SIGNUP_EMAIL_WAITING: "인증 대기중",
  ID_SIGNUP_EMAIL_CODE_PLACEHOLDER: "인증코드를 입력해주세요.",
  ID_SIGNUP_CODE_VERIFY_ERROR: "인증코드를 바르게 입력해 주세요.",
  ID_SIGNUP_CODE_VERIFY_TIMEOUT:
    "인증코드 입력 시간이 만료되었습니다. 인증 코드를 다시 발송해주세요.",
  ID_SIGNUP_EMAIL_VERIFIED: "인증 완료",
  ID_SIGNUP_EMAIL_VERIFIED_ERROR: "인증 대기중",
  ID_SIGNUP_SUCCESS: "회원가입이\n완료되었습니다.",
  ID_SIGNUP_CONFIRM: "확인",
  ID_SIGNUP_SENT_EMAIL_TITLE: "인증메일 발송",
  ID_SIGNUP_SENT_EMAIL_MSG: "입력하신 이메일로 인증 메일이 발송되었습니다.",
  ID_SIGNUP_OVERLIMIT_ERR:
    "닉네임은 한글 8글자, 영문 & 숫자 16글자까지 사용 가능합니다.",
  ID_SIGNUP_DUPLICATE_ERR:
    "이미 닉네임이 있습니다. 다른 닉네임을 입력해 주세요.",
  ID_SIGNUP_BADWORD_ERR:
    "닉네임에 금칙어가 포함되어 있습니다. 다른 닉네임을 입력해 주세요.",
  ID_SIGNUP_PATTERN_ERR: "닉네임에 공백, 특수문자는 사용할 수 없습니다.",
};

export default SignUp_ko;
